var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"py-0"},[_c('v-text-field',{attrs:{"outlined":"","filled":"","label":"Text jawaban singkat","hide-details":"auto"},model:{value:(_vm.correct),callback:function ($$v) {_vm.correct=$$v},expression:"correct"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }